import React, {useState, useEffect} from 'react';
import {Tooltip} from "primereact/tooltip";
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {Dropdown} from "primereact/dropdown";
import {Button} from 'primereact/button';
import {TabPanel, TabView} from "primereact/tabview";
import {Link} from "react-router-dom";
import {InputText} from "primereact/inputtext";
import {Calendar} from "primereact/calendar";
import {addLocale} from "primereact/api";
import {Timeline} from "primereact/timeline";
import {SplitButton} from "primereact/splitbutton";
import {InputSwitch} from "primereact/inputswitch";
import {Message} from "primereact/message";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Dialog} from "primereact/dialog";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment/moment";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";

import _FM_ReservationGuestListComponent from "./_FM_ReservationGuestListComponent";
import _FM_ReservationBillingdataFormComponent from "./_FM_ReservationBillingdataFormComponent";
import _FM_ReservationAttachFormComponent from "./_FM_ReservationAttachFormComponent";
import _FM_FolioListComponent from "../../components/_FM_folio/_FM_FolioListComponent";
import _FM_ReservationErrorsListComponent from "./_FM_ReservationErrorsListComponent";
import _FM_ReceiptListComponent from "../_FM_receipt/_FM_ReceiptListComponent";
import _FM_ReservationEzeepricesListComponent from "./_FM_ReservationEzeepricesListComponent";
import _FM_ReservationResnwebListComponent from "./_FM_ReservationResnwebListComponent";
import _FM_GroupFormComponent from "../_FM_group/_FM_GroupFormComponent";
import ReservationCountrySpecificComponent from "./_FM_ReservationCountrySpecificComponent";
import {closeMercureSubscription, openMercureSubscription} from "../../util/mercure";

const _FM_ReservationFormComponent = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({
    status: 'confirmed',
  });
  const [newFormData, setNewFormData] = useState({});
  const [unit, setUnit] = useState([]);
  const [berth, setBerth] = useState([]);
  const [chanel, setChanel] = useState([]);
  const [priceCategories, setPriceCategories] = useState([]);
  const [possibleStatuses, setPossibleStatuses] = useState([]);
  const [email, setEmail] = useState({
    language: Cookies.get("language").toUpperCase(),
    client_domain: process.env.REACT_APP_APP_PROTOCOL + window.location.hostname.split('.')[0]
      + "." + process.env.REACT_APP_APP_HOST.replace('/#/', '/#')
  });
  const [statuses, setStatuses] = useState([]);
  const [reservationGroup, setReservationGroup] = useState(null);
  const [groupDialog, setGroupDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hotelConnectRetryLoading, setHotelConnectRetryLoading] = useState(false);
  const [hotelConnectCheckinRetryLoading, setHotelConnectCheckinRetryLoading] = useState(false);
  const [hotelConnectCheckoutRetryLoading, setHotelConnectCheckoutRetryLoading] = useState(false);
  const [hotelConnectRoomChangeRetryLoading, setHotelConnectRoomChangeRetryLoading] = useState(false);
  const [locking, setLocking] = useState(false);
  const [chooseBerth, setChooseBerth] = useState(false);
  const [guestInfos, setGuestInfos] = useState([]);
  const [countrySpecificEnabled, setCountrySpecificEnabled] = useState(null);

  const [dailyReservationAllowed, setDailyReservationAllowed] = useState(false);
  const [dailyReservationOnly, setDailyReservationOnly] = useState(false);
  const [reservationFromToInputType, setReservationFromToInputType] = useState('merged');
  const [reservedFromDate, setReservedFromDate] = useState();
  const [reservedFromTime, setReservedFromTime] = useState('15:00');
  const [reservedToDate, setReservedToDate] = useState();
  const [reservedToTime, setReservedToTime] = useState('10:00');

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  const getReservationNavigationPath = (reservationId) => {
    const currentAction = action || 'read';
    const hash = window.location.hash.toString();

    if (hash.includes('#/calendar')) {
      return '/calendar/' + currentAction + '/' + reservationId;
    }
    if (hash.includes('#/control-panel')) {
      return '/control-panel/reservation/' + currentAction + '/' + reservationId;
    }
    if (hash.includes('#/folio')) {
      return '/folio/' + currentAction + '/' + reservationId;
    }
    return '/reservation/' + currentAction + '/' + reservationId;
  }

  const getCloseNavigationPath = () => {
    const hash = window.location.hash.toString();
    return hash.includes('#/calendar') ? '/calendar' : '/reservation';
  }

  const getHotelConnectStatusMeta = (status) => {
    const normalizedStatus = typeof status === 'string' ? status.toLowerCase().trim() : '';
    const neutralStyle = {backgroundColor: '#dddddd', color: '#5f656b'};
    if (normalizedStatus === 'success') {
      return {badgeClass: '', label: t('hotelconnect_status_success'), style: {backgroundColor: '#0abb87', color: '#ffffff'}};
    }
    if (normalizedStatus === 'failed') {
      return {badgeClass: '', label: t('hotelconnect_status_failed'), style: {backgroundColor: '#f7a2a2', color: '#5f656b'}};
    }
    if (normalizedStatus === 'skipped') {
      return {badgeClass: '', label: t('hotelconnect_status_skipped'), style: neutralStyle};
    }
    return {badgeClass: '', label: t('hotelconnect_status_not_started'), style: neutralStyle};
  };

  const setHotelConnectSyncStateFromPayload = (payload) => {
    if (!payload) {
      return;
    }

    const getValue = (camelKey, snakeKey, previousValue = null) => {
      if (payload?.[camelKey] !== undefined && payload?.[camelKey] !== null) {
        return payload[camelKey];
      }
      if (payload?.[snakeKey] !== undefined && payload?.[snakeKey] !== null) {
        return payload[snakeKey];
      }
      return previousValue;
    };

    setFormData((prevState) => ({
      ...prevState,
      hotelConnectFoglalasStatus: getValue('hotelConnectFoglalasStatus', 'hotel_connect_foglalas_status', prevState?.hotelConnectFoglalasStatus ?? prevState?.hotel_connect_foglalas_status ?? null),
      hotelConnectFoglalasError: getValue('hotelConnectFoglalasError', 'hotel_connect_foglalas_error', prevState?.hotelConnectFoglalasError ?? prevState?.hotel_connect_foglalas_error ?? null),
      hotelConnectFoglalasSyncedAt: getValue('hotelConnectFoglalasSyncedAt', 'hotel_connect_foglalas_synced_at', prevState?.hotelConnectFoglalasSyncedAt ?? prevState?.hotel_connect_foglalas_synced_at ?? null),
      hotelConnectCheckinStatus: getValue('hotelConnectCheckinStatus', 'hotel_connect_checkin_status', prevState?.hotelConnectCheckinStatus ?? prevState?.hotel_connect_checkin_status ?? null),
      hotelConnectCheckinError: getValue('hotelConnectCheckinError', 'hotel_connect_checkin_error', prevState?.hotelConnectCheckinError ?? prevState?.hotel_connect_checkin_error ?? null),
      hotelConnectCheckinSyncedAt: getValue('hotelConnectCheckinSyncedAt', 'hotel_connect_checkin_synced_at', prevState?.hotelConnectCheckinSyncedAt ?? prevState?.hotel_connect_checkin_synced_at ?? null),
      hotelConnectCheckoutStatus: getValue('hotelConnectCheckoutStatus', 'hotel_connect_checkout_status', prevState?.hotelConnectCheckoutStatus ?? prevState?.hotel_connect_checkout_status ?? null),
      hotelConnectCheckoutError: getValue('hotelConnectCheckoutError', 'hotel_connect_checkout_error', prevState?.hotelConnectCheckoutError ?? prevState?.hotel_connect_checkout_error ?? null),
      hotelConnectCheckoutSyncedAt: getValue('hotelConnectCheckoutSyncedAt', 'hotel_connect_checkout_synced_at', prevState?.hotelConnectCheckoutSyncedAt ?? prevState?.hotel_connect_checkout_synced_at ?? null),
      hotelConnectRoomChangeStatus: getValue('hotelConnectRoomChangeStatus', 'hotel_connect_room_change_status', prevState?.hotelConnectRoomChangeStatus ?? prevState?.hotel_connect_room_change_status ?? null),
      hotelConnectRoomChangeError: getValue('hotelConnectRoomChangeError', 'hotel_connect_room_change_error', prevState?.hotelConnectRoomChangeError ?? prevState?.hotel_connect_room_change_error ?? null),
      hotelConnectRoomChangeSyncedAt: getValue('hotelConnectRoomChangeSyncedAt', 'hotel_connect_room_change_synced_at', prevState?.hotelConnectRoomChangeSyncedAt ?? prevState?.hotel_connect_room_change_synced_at ?? null),
    }));
  };

  const validate = (data) => {
    let errors = {};
    if (!data.residential_unit) {
      errors.residential_unit = t('required_field');
    }
    if (!data.reserved_from) {
      errors.reserved_from = t('required_field');
    }
    const hasContactEmail = !!(data.contact_email && String(data.contact_email).trim());
    const hasContactNumber = !!(data.contact_number && String(data.contact_number).trim());
    if (!hasContactEmail && !hasContactNumber) {
      errors.contact_email = t('required_field');
      errors.contact_number = t('required_field');
    }
    if (!data.contact_name) {
      errors.contact_name = t('required_field');
    }
    if (!data.number_of_guests) {
      errors.number_of_guests = t('required_field');
    }
    if (!data.price_category) {
      errors.price_category = t('required_field');
    }
    if (!data.guest_information_request_page) {
      errors.guest_information_request_page = t('required_field');
    }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const normalizeToIso = (value) => {
      if (!value) return null;
      const parsedDate = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(parsedDate.getTime())) return null;
      return parsedDate.toISOString();
    };
    const getDatePart = (dateValue) => {
      if (!dateValue) return null;
      if (typeof dateValue === 'string' && moment(dateValue, 'YYYY-MM-DD', true).isValid()) {
        return moment(dateValue, 'YYYY-MM-DD').format('YYYY-MM-DD');
      }
      const parsedDate = moment(dateValue);
      if (!parsedDate.isValid()) return null;
      return parsedDate.format('YYYY-MM-DD');
    };
    const buildUtcIso = (dateValue, timeValue, fallbackTime = '00:00') => {
      const datePart = getDatePart(dateValue);
      if (!datePart) return null;
      const combinedLocalDateTime = moment(`${datePart} ${timeValue || fallbackTime}`, 'YYYY-MM-DD HH:mm', true);
      if (!combinedLocalDateTime.isValid()) return null;
      return combinedLocalDateTime.utc().toISOString();
    };
    const effectiveReservedFromTime = dailyReservationOnly ? reservedFromTime : '15:00';
    const effectiveReservedToTime = dailyReservationOnly ? reservedToTime : '10:00';
    const effectiveReservedToDate = reservedToDate;
    const _fromUtcIso = buildUtcIso(reservedFromDate, effectiveReservedFromTime, '15:00');
    const _toUtcIso = buildUtcIso(effectiveReservedToDate, effectiveReservedToTime, '10:00');
    data = {
      ...data,
      reserved_from: _fromUtcIso,
      reserved_to: _toUtcIso
    }
    let newData = {
      ...newFormData,
    }
    const originalReservedFromIso = normalizeToIso(formData?.reserved_from);
    const originalReservedToIso = normalizeToIso(formData?.reserved_to);
    const hasReservedDateChange =
      Object.prototype.hasOwnProperty.call(newFormData, 'reserved_from') ||
      Object.prototype.hasOwnProperty.call(newFormData, 'reserved_to');
    if (
      hasReservedDateChange ||
      _fromUtcIso !== originalReservedFromIso ||
      _toUtcIso !== originalReservedToIso
    ) {
      newData.reserved_from = _fromUtcIso;
      newData.reserved_to = _toUtcIso;
    }
    if (formData && formData.id) {
      apiCall('patch', 'reservation/' + formData.id, newData)
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({})
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderReservationGuestList: Math.random(),
            rerenderReservationList: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          // if (error.status && error.status === 400 && error.response.data && error.response.data.data) {
          //   let _message = ''
          //   Object.keys(error.response.data.data).forEach(key => {
          //     error.response.data.data[key].forEach(value => {
          //       _message += value + " "
          //     });
          //   });
          //   window.App.customToastShow('warn', error.response.data.message, _message);
          // } else {
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
          // }
        })
    } else {
      apiCall('post', 'reservation', data)
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderReservationGuestList: Math.random(),
            rerenderReservationList: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          } else {
            if (window.location.hash.toString().includes('#/reservation')) {
              navigate('/reservation/update/' + response?.data?.data?.id)
            }
          }
        })
        .catch(error => {
          setLoading(false)
          // if (error.status && error.status === 400 && error.response.data && error.response.data.data) {
          //   let _message = ''
          //   Object.keys(error.response.data.data).forEach(key => {
          //     error.response.data.data[key].forEach(value => {
          //       _message += value + " "
          //     });
          //   });
          //   window.App.customToastShow('warn', error.response.data.message, _message);
          // } else {
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
          // }
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => {
    if (loading) return false;
    return !!(meta.error);
  };
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-validate">{meta.error}</small>;
  };

  const reservationId = window.App.urlVars().reservationId ?? id;

  const refreshReservationSyncData = () => {
    if (!reservationId) {
      return;
    }
    apiCall('get', 'reservation/' + reservationId)
      .then((response) => {
        setHotelConnectSyncStateFromPayload(response?.data?.data || {});
      })
      .catch(() => {
      });
  };

  const triggerAsyncStatusSyncRefresh = () => {
    setTimeout(() => {
      refreshReservationSyncData();
    }, 1500);
    setTimeout(() => {
      refreshReservationSyncData();
    }, 5000);
  };

  const retryHotelConnectFoglalasSync = () => {
    if (!reservationId) {
      return;
    }

    setHotelConnectRetryLoading(true);
    apiCall('post', 'reservation/' + reservationId + '/hotelconnect-ntak-foglalas-sync')
      .then(response => {
        setHotelConnectSyncStateFromPayload(response?.data?.data || {});
        window.App.toastShow('success', t('success'), response?.data?.message || t('hotelconnect_sync_started_message'));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error?.response);
      })
      .finally(() => {
        setHotelConnectRetryLoading(false);
      })
  };

  const retryHotelConnectCheckinSync = () => {
    if (!reservationId) {
      return;
    }

    setHotelConnectCheckinRetryLoading(true);
    apiCall('post', 'reservation/' + reservationId + '/hotelconnect-ntak-checkin-sync')
      .then(response => {
        setHotelConnectSyncStateFromPayload(response?.data?.data || {});
        window.App.toastShow('success', t('success'), response?.data?.message || t('hotelconnect_sync_started_message'));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error?.response);
      })
      .finally(() => {
        setHotelConnectCheckinRetryLoading(false);
      })
  };

  const retryHotelConnectCheckoutSync = () => {
    if (!reservationId) {
      return;
    }

    setHotelConnectCheckoutRetryLoading(true);
    apiCall('post', 'reservation/' + reservationId + '/hotelconnect-ntak-checkout-sync')
      .then(response => {
        setHotelConnectSyncStateFromPayload(response?.data?.data || {});
        window.App.toastShow('success', t('success'), response?.data?.message || t('hotelconnect_sync_started_message'));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error?.response);
      })
      .finally(() => {
        setHotelConnectCheckoutRetryLoading(false);
      })
  };

  const retryHotelConnectRoomChangeSync = () => {
    if (!reservationId) {
      return;
    }

    setHotelConnectRoomChangeRetryLoading(true);
    apiCall('post', 'reservation/' + reservationId + '/hotelconnect-ntak-room-change-sync')
      .then(response => {
        setHotelConnectSyncStateFromPayload(response?.data?.data || {});
        window.App.toastShow('success', t('success'), response?.data?.message || t('hotelconnect_sync_started_message'));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error?.response);
      })
      .finally(() => {
        setHotelConnectRoomChangeRetryLoading(false);
      })
  };

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    const selectedUnitId = formData?.residential_unit?.id || formData?.residential_unit;

    if (selectedUnitId) {
      apiCall('get', 'berth' + '?search[residential_unit][operator]=%3D&search[residential_unit][value]=' + selectedUnitId)
        .then(response => {
          setLoading(false)
          setBerth(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
      apiCall('get', 'residential-unit/' + selectedUnitId)
        .then(response => {
          if (response.data.data && response.data.data.residential_category && response.data.data.residential_category.id) {
            apiCall('get', 'residential-category/' + response.data.data.residential_category.id)
              .then(response => {
                if (response.data.data && response.data.data.accommodation && response.data.data.accommodation.id) {
                  if (formData.id) {
                    apiCall('get', 'residential-unit?search[accommodation]=' + response.data.data.accommodation.id)
                      .then(response => {
                        setUnit((response.data.data.items || []).map((unitItem) => {
                          const accommodationName = unitItem?.residential_category?.accommodation?.name;
                          return {
                            ...unitItem,
                            name: accommodationName ? `${unitItem?.name} (${accommodationName})` : unitItem?.name,
                          };
                        }));
                      })
                      .catch(error => {
                      })
                  }
                  apiCall('get', 'accommodation/' + response.data.data.accommodation.id)
                    .then(response => {
                      setCountrySpecificEnabled(response?.data?.data?.country?.toUpperCase() === 'HU')
                      setReservationFromToInputType(response?.data?.data?.reservation_from_to_input_type ?? null)
                      if (response.data.data && response.data.data.daily_reservation_allowed && response.data.data.daily_reservation_allowed === true) {
                        setDailyReservationAllowed(true)
                      } else {
                        setDailyReservationAllowed(false)
                      }
                    })
                    .catch(error => {
                    })
                  apiCall('get', 'price-category?search[accommodation][operator]=%3D&search[accommodation][value]=' + response.data.data.accommodation.id)
                    .then(response => {
                      setPriceCategories(response.data.data.items);
                    })
                    .catch(error => {
                      setLoading(false)
                    })
                }
              })
              .catch(error => {
              })
          }
        })
        .catch(error => {
        })
    }
    if (formData.residential_unit && formData.residential_unit.id) {
      setFormData((prevState) => ({
        ...prevState,
        residential_unit: prevState?.residential_unit?.id,
      }));
    }
  }, [formData.id, formData.residential_unit, window.App.state.rerenderReservationList])

  useEffect(() => {
    const reservationGroupId = formData?.reservation_group?.id || formData?.reservation_group;

    if (!reservationGroupId) {
      setReservationGroup(null);
      return;
    }

    if (formData?.reservation_group?.group?.name) {
      setReservationGroup(formData.reservation_group);
      return;
    }

    apiCall('get', 'reservation-group/' + reservationGroupId)
      .then(response => {
        setReservationGroup(response?.data?.data || null);
      })
      .catch(() => {
      })
  }, [formData?.reservation_group])

  useEffect(() => {
    if (formData.berth && formData.berth.id) {
      setFormData((prevState) => ({
        ...prevState,
        berth: prevState?.berth?.id,
        residential_unit: prevState?.berth?.residential_unit?.id,
      }));
    }
  }, [formData.berth])

  useEffect(() => {
    if (formData.reserved_from) {
      const localMoment = moment.utc(formData.reserved_from).local();
      if (!localMoment.isValid()) return;
      setReservedFromDate(localMoment.format('YYYY-MM-DD'))
      setReservedFromTime(localMoment.format('HH:mm'))
    }
  }, [formData.reserved_from])

  useEffect(() => {
    if (formData.reserved_to) {
      const localMoment = moment.utc(formData.reserved_to).local();
      if (!localMoment.isValid()) return;
      setReservedToDate(localMoment.format('YYYY-MM-DD'))
      setReservedToTime(localMoment.format('HH:mm'))
    }
    if (formData.reserved_to && moment(formData.reserved_to).diff(moment(formData.reserved_from), 'hours') < 12) {
      setDailyReservationOnly(true)
    }
  }, [formData.reserved_to])

  useEffect(() => {
    setLoading(true)
    let query = ''
    // if (localStorage.getItem('selectedAccommodation')) {
    //   query = '?search[accommodation]=' + localStorage.getItem('selectedAccommodation')
    // }
    if (reservationId) {
      apiCall('get', 'reservation/' + reservationId)
        .then(response => {
          setLoading(false)
          const reservationData = response.data.data;
          setFormData(reservationData);
          let _statuses = [
            {
              status: 'pending',
              label: t('pending'),
              date: null,
              step: 0,
            },
            {
              status: 'confirmed',
              label: t('reserved'),
              date: null,
              step: 1,
            },
            {
              status: 'checked_in',
              label: t('checked_in'),
              date: response.data.data.checked_in,
              step: 2,
            },
            {
              status: 'checked_out',
              label: t('checked_out'),
              date: reservationData.checked_out,
              step: 3,
            },
            {
              status: 'cancelled',
              label: t('cancelled'),
              date: null,
              step: 4,
            },
          ]
          _statuses.map((status, index) => {
            const statusForHistory = status.status === 'checked_out' && reservationData.status === 'relocated'
              ? 'relocated'
              : status.status;
            apiCall('get', 'reservation-status-change?search[reservation][operator]=%3D&search[reservation][value]=' + id
              + '&search[new_status][operator]=%3D&search[new_status][value]=' + statusForHistory)
              .then(response => {
                if (response.data.data.items && response.data.data.items[0]) {
                  _statuses[index] = {
                    status: status.status,
                    label: status.label,
                    date: response.data.data.items[0].created_at_snapshot,
                    step: status.step
                  }
                }
              })
              .catch(error => {

              })
          })
          setStatuses(_statuses)
          setReservedFromDate(response.data.data?.reserved_from)
          setReservedToDate(response.data.data?.reserved_to)
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    if (!reservationId) {
      apiCall('get', 'residential-unit' + query)
        .then(response => {
          setLoading(false)
          setUnit((response.data.data.items || []).map((unitItem) => {
            const accommodationName = unitItem?.residential_category?.accommodation?.name;
            return {
              ...unitItem,
              name: accommodationName ? `${unitItem?.name} (${accommodationName})` : unitItem?.name,
            };
          }));
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    apiCall('get', 'reservation-channel')
      .then(response => {
        setLoading(false)
        setChanel(response.data.data.items);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'guest-information-request-page')
      .then(response => {
        setGuestInfos(response.data.data.items);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [id, reservationId, action, window.App.state.rerenderReservationList])

  useEffect(() => {
    if (!reservationId) {
      return undefined;
    }

    const topic = process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.replace('/api', '')
      + Cookies.get("instanceId") + "/api/reservation/" + reservationId;
    const eventSource = openMercureSubscription({
      topics: [topic],
      onMessage: (event) => {
        try {
          const data = JSON.parse(event?.data || '{}');
          const eventName = data?.event;
          const updateEvents = [
            'hotelconnect_ntak_foglalas_sync_updated',
            'hotelconnect_ntak_checkin_sync_updated',
            'hotelconnect_ntak_checkout_sync_updated',
            'hotelconnect_ntak_room_change_sync_updated',
          ];
          const refreshEvents = [
            'hotelconnect_ntak_checkin_sync_succeeded',
            'hotelconnect_ntak_checkin_sync_failed',
            'hotelconnect_ntak_checkout_sync_succeeded',
            'hotelconnect_ntak_checkout_sync_failed',
            'hotelconnect_ntak_room_change_sync_succeeded',
            'hotelconnect_ntak_room_change_sync_failed',
          ];

          if (!updateEvents.includes(eventName) && !refreshEvents.includes(eventName)) {
            return;
          }
          if (updateEvents.includes(eventName)) {
            setHotelConnectSyncStateFromPayload(data);
          } else {
            refreshReservationSyncData();
          }
        } catch (error) {
        }
      }
    });

    if (!eventSource) {
      return undefined;
    }

    return () => {
      closeMercureSubscription(eventSource);
    };
  }, [reservationId]);

  useEffect(() => {
    if (!priceCategories[0] || formData.price_category) return;
    const defaultPriceCategoryId = priceCategories[0].id;
    setFormData((prev) => ({
      ...prev,
      price_category: defaultPriceCategoryId,
    }));
  }, [priceCategories, formData.price_category]);

  useEffect(() => {
    if (!guestInfos[0] || formData.guest_information_request_page) return;
    const defaultGuestInfoId = guestInfos[0].id;
    setFormData((prev) => ({
      ...prev,
      guest_information_request_page: defaultGuestInfoId,
    }));
  }, [guestInfos, formData.guest_information_request_page]);

  const createFinalInvoice = () => {
    setLoading(true);
    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation/" + formData.id + "/final-invoice-now",
      formData,
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
      .then(response => {
        window.App.setState({
          rerenderReceiptList: Math.random(),
          rerenderFolioList: Math.random(),
        })
        window.App.toastShow('success', t('success'), response.data.message)
        setLoading(false)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setLoading(false)
      })
  }

  const hotelConnectFoglalasStatus = formData?.hotelConnectFoglalasStatus ?? formData?.hotel_connect_foglalas_status ?? null;
  const normalizedHotelConnectFoglalasStatus = typeof hotelConnectFoglalasStatus === 'string'
    ? hotelConnectFoglalasStatus.toLowerCase().trim()
    : '';
  const hotelConnectFoglalasStatusMeta = getHotelConnectStatusMeta(hotelConnectFoglalasStatus);
  const isHotelConnectFoglalasSyncFailed = normalizedHotelConnectFoglalasStatus === 'failed';
  const hotelConnectFoglalasError = formData?.hotelConnectFoglalasError ?? formData?.hotel_connect_foglalas_error ?? null;

  const hotelConnectCheckinStatus = formData?.hotelConnectCheckinStatus ?? formData?.hotel_connect_checkin_status ?? null;
  const normalizedHotelConnectCheckinStatus = typeof hotelConnectCheckinStatus === 'string'
    ? hotelConnectCheckinStatus.toLowerCase().trim()
    : '';
  const hotelConnectCheckinStatusMeta = getHotelConnectStatusMeta(hotelConnectCheckinStatus);
  const isHotelConnectCheckinSyncFailed = normalizedHotelConnectCheckinStatus === 'failed';
  const hotelConnectCheckinError = formData?.hotelConnectCheckinError ?? formData?.hotel_connect_checkin_error ?? null;

  const hotelConnectCheckoutStatus = formData?.hotelConnectCheckoutStatus ?? formData?.hotel_connect_checkout_status ?? null;
  const normalizedHotelConnectCheckoutStatus = typeof hotelConnectCheckoutStatus === 'string'
    ? hotelConnectCheckoutStatus.toLowerCase().trim()
    : '';
  const hotelConnectCheckoutStatusMeta = getHotelConnectStatusMeta(hotelConnectCheckoutStatus);
  const isHotelConnectCheckoutSyncFailed = normalizedHotelConnectCheckoutStatus === 'failed';
  const hotelConnectCheckoutError = formData?.hotelConnectCheckoutError ?? formData?.hotel_connect_checkout_error ?? null;
  const hotelConnectRoomChangeStatus = formData?.hotelConnectRoomChangeStatus ?? formData?.hotel_connect_room_change_status ?? null;
  const normalizedHotelConnectRoomChangeStatus = typeof hotelConnectRoomChangeStatus === 'string'
    ? hotelConnectRoomChangeStatus.toLowerCase().trim()
    : '';
  const hotelConnectRoomChangeStatusMeta = getHotelConnectStatusMeta(hotelConnectRoomChangeStatus);
  const isHotelConnectRoomChangeSyncFailed = normalizedHotelConnectRoomChangeStatus === 'failed';
  const hotelConnectRoomChangeError = formData?.hotelConnectRoomChangeError ?? formData?.hotel_connect_room_change_error ?? null;
  const showHotelConnectRoomChangeSync = Boolean(formData?.relocated_from);
  const reservationFormSyncIdentifier = formData?.id || reservationId || 'new';

  const renderHotelConnectSyncRow = (rowKey, label, statusMeta, isFailed, errorText, retryLoading, retryAction) => (
    <li className="p-mb-3" key={rowKey}>
      <div className="p-d-flex p-ai-center p-jc-between p-flex-wrap" style={{gap: '0.5rem'}}>
        <div className="p-d-flex p-ai-center" style={{gap: '0.4rem'}}>
          {errorText &&
            <>
              <span
                className={`tt-hotelconnect-error-${rowKey}-form-${reservationFormSyncIdentifier}`}
                data-pr-tooltip={errorText}
                style={{display: 'inline-flex', color: '#f44336'}}
              >
                <i className="pi pi-info-circle" style={{fontSize: '0.8rem'}}></i>
              </span>
              <Tooltip target={`.tt-hotelconnect-error-${rowKey}-form-${reservationFormSyncIdentifier}`}/>
            </>
          }
          <span>{label}</span>
        </div>
        <span
          className={classNames(
            'p-badge p-text-bold',
            statusMeta.badgeClass,
            `tt-hotelconnect-retry-${rowKey}-form-${reservationFormSyncIdentifier}`
          )}
          data-pr-tooltip={isFailed ? t('hotelconnect_sync_retry_label') : undefined}
          role={isFailed ? 'button' : undefined}
          tabIndex={isFailed ? (retryLoading ? -1 : 0) : undefined}
          style={{
            ...statusMeta.style,
            width: '110px',
            minWidth: '110px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.35rem',
            cursor: isFailed && !retryLoading ? 'pointer' : 'default'
          }}
          onClick={() => {
            if (!isFailed || retryLoading) {
              return;
            }
            retryAction();
          }}
          onKeyDown={(event) => {
            if (!isFailed || retryLoading) {
              return;
            }
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              retryAction();
            }
          }}
        >
          <span>{statusMeta.label}</span>
          {isFailed &&
            <>
              <i
                className={`pi ${retryLoading ? 'pi-spin pi-spinner' : 'pi-refresh'}`}
                style={{color: 'inherit', fontSize: '0.8rem'}}
              ></i>
              <Tooltip target={`.tt-hotelconnect-retry-${rowKey}-form-${reservationFormSyncIdentifier}`}/>
            </>
          }
        </span>
      </div>
    </li>
  );

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
            {t('reservation_form')}
            {formData.relocated_to &&
              <>
                <span
                  className={"tt-relocated-to-reservation-form-info-" + formData.id + " p-ml-2 p-mr-2"}
                  data-pr-tooltip={t('reservation_number') + ': ' + (formData?.relocated_to?.public_id || '-') + ' (#' + (formData?.relocated_to?.id || '-') + ')'}>
                  <i className={"pi pi-info-circle"}
                     style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                </span>
                <Tooltip target={".tt-relocated-to-reservation-form-info-" + formData.id} autoHide={false}>
                  <span>
                    {t('reservation_number')}:{' '}
                    <span
                      style={{cursor: 'pointer', textDecoration: 'underline'}}
                      onClick={() => navigate(getReservationNavigationPath(formData.relocated_to.id))}>
                      {formData.relocated_to.public_id} (#{formData.relocated_to.id})
                    </span>
                  </span>
                </Tooltip>
                <span
                  className={"p-badge p-badge-warning p-text-nowrap"}>
                  {t('relocated_to')}
                  <i className="pi pi-sign-in p-ml-1" style={{fontSize: "0.6rem"}}></i>
                </span>
              </>
            }
            {formData.relocated_from &&
              <>
                <span
                  className={"tt-relocated-from-reservation-form-info-" + formData.id + " p-mr-2 p-ml-2"}
                  data-pr-tooltip={t('reservation_number') + ': ' + (formData?.relocated_from?.public_id || '-') + ' (#' + (formData?.relocated_from?.id || '-') + ')'}>
                  <i className={"pi pi-info-circle"}
                     style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                </span>
                <Tooltip target={".tt-relocated-from-reservation-form-info-" + formData.id} autoHide={false}>
                  <span>
                    {t('reservation_number')}:{' '}
                    <span
                      style={{cursor: 'pointer', textDecoration: 'underline'}}
                      onClick={() => navigate(getReservationNavigationPath(formData.relocated_from.id))}>
                      {formData.relocated_from.public_id} (#{formData.relocated_from.id})
                    </span>
                  </span>
                </Tooltip>
                <span
                  className={"p-badge p-badge-warning p-text-nowrap"}>
                  <i className="pi pi-sign-out p-mr-1" style={{fontSize: "0.6rem"}}></i>
                  {t('relocated_from')}
                </span>
              </>
            }
            <span style={{float: 'right', fontSize: '1rem'}} className={"p-text-normal p-mt-1"}>
               {formData.errors && formData.errors[0] &&
                 <span style={{cursor: "help"}} onClick={() => {
                   const targetElement = document.getElementById('errors');
                   if (targetElement) {
                     targetElement.scrollIntoView({behavior: 'smooth', block: 'start'});
                   }
                 }}>
                    <i className={"pi pi-exclamation-triangle p-mr-2"}
                       style={{position: "relative", top: '1px'}}></i>{t('error_found_in_reservation')}
                  </span>
               }
            </span>
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"} style={{maxWidth: '290px'}}>
          {formData?.id &&
            <Button type="button"
                    icon={"pi pi-copy"}
                    loading={loading}
                    label={t('final_invoice_create')}
                    onClick={() => {
                      window.App.setState({[`confirmFinalInvoiceCreate${formData.id}`]: true})
                    }}
                    className="p-button-success p-ml-2">
            </Button>
          }
          <ConfirmDialog group="declarative"
                         visible={window.App.state[`confirmFinalInvoiceCreate${formData.id}`]}
                         acceptLabel={t('yes')}
                         rejectLabel={t('no')}
                         onHide={() => {
                           window.App.setState({[`confirmFinalInvoiceCreate${formData.id}`]: false})
                         }}
                         message={t('final_invoice_create_confirm_message')}
                         header={t('final_invoice_create_confirm_title')}
                         icon="pi pi-exclamation-triangle"
                         accept={() => {
                           window.App.setState({[`confirmFinalInvoiceCreate${formData.id}`]: false})
                           createFinalInvoice()
                         }}
                         reject={() => {
                           window.App.setState({[`confirmFinalInvoiceCreate${formData.id}`]: false})
                         }}/>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(getCloseNavigationPath())
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"} style={{clear: 'both'}}>
        {formData.accommodation && formData.accommodation &&
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('accommodation')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              <span className={"p-text-nowrap"}>{formData?.accommodation?.name}<span
                className={"tt-auto-invoice p-ml-2"}
                data-pr-tooltip={formData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? t('auto_invoice_tooltip_active') : t('auto_invoice_tooltip_inactive')}><svg
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                className={"auto-invoice-icon"} style={{
                color: formData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? '#0abb87' : '#dddddd',
                position: 'relative',
                bottom: '-3px'
              }}><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8"/><path d="M5 21l2.5-1.5L10 21l2.5-1.5L14 21l1.5-1"/><path
                d="M9 7h6"/><path d="M9 11h4"/><path d="M18 14a3 3 0 1 0 3 3"/><path
                d="M21 20v-3h-3"/></svg></span><Tooltip target=".tt-auto-invoice"/></span>
            </p>
          </div>
        }
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('reservation_number')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold p-text-nowrap"}>
            {formData.association_code ? (
              <>
                <span className={"tt-association-code-reservation-form-info-" + formData.id + " p-mr-2"}
                      data-pr-tooltip={formData.association_code}>
                  <i className={"pi pi-info-circle"}
                     style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                </span>
                <Tooltip target={".tt-association-code-reservation-form-info-" + formData.id}/>
                <span className={"p-badge"}
                      style={{
                        fontSize: '1rem',
                        backgroundColor: formData?.status
                          ? formData?.status?.toLowerCase() === 'pending'
                            ? '#dddddd'
                            : formData?.status?.toLowerCase() === 'confirmed'
                              ? '#f1eea5'
                              : formData?.status?.toLowerCase() === 'cancelled'
                                ? '#f7a2a2'
                                : formData?.status?.toLowerCase() === 'checked_in'
                                  ? '#3ec0e9'
                                  : formData?.status?.toLowerCase() === 'checked_out'
                                    ? '#0abb87'
                                    : formData?.status?.toLowerCase() === 'no_show'
                                      ? '#8a2be2'
                                      : '#ccc'
                          : undefined,
                        color: formData?.status
                          ? formData?.status?.toLowerCase() === 'pending' || formData?.status?.toLowerCase() === 'confirmed'
                            ? '#5f656b'
                            : formData?.status?.toLowerCase() === 'cancelled'
                              ? '#5f656b'
                            : formData?.status?.toLowerCase() === 'no_show'
                              ? '#fff'
                              : undefined
                          : undefined
                      }}>
                  {formData?.association_code?.split(' | ').pop()?.trim()}
                </span>
              </>
            ) : t('no_id_yet')}
          </p>
        </div>
        {formData.auto_check_in_at &&
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('auto_check_in_time')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              <span className={"tt-auto-check-in-reservation-form-" + formData.id}
                    data-pr-tooltip={t('auto_check_in_tooltip')}>
                <i className={"pi pi-info-circle p-mr-2"}
                   style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
              </span>
              <Tooltip target={".tt-auto-check-in-reservation-form-" + formData.id}/>
              <span className={"p-badge"}
                    style={{
                      fontSize: '1rem',
                      backgroundColor: formData?.status
                        ? formData?.status?.toLowerCase() === 'pending'
                          ? '#dddddd'
                          : formData?.status?.toLowerCase() === 'confirmed'
                            ? '#f1eea5'
                            : formData?.status?.toLowerCase() === 'cancelled'
                              ? '#f7a2a2'
                              : formData?.status?.toLowerCase() === 'checked_in'
                                ? '#3ec0e9'
                                : formData?.status?.toLowerCase() === 'checked_out'
                                  ? '#0abb87'
                                  : formData?.status?.toLowerCase() === 'no_show'
                                    ? '#8a2be2'
                                    : '#ccc'
                        : undefined,
                      color: formData?.status
                        ? formData?.status?.toLowerCase() === 'pending' || formData?.status?.toLowerCase() === 'confirmed'
                          ? '#5f656b'
                          : formData?.status?.toLowerCase() === 'cancelled'
                            ? '#5f656b'
                          : formData?.status?.toLowerCase() === 'no_show'
                            ? '#fff'
                            : undefined
                        : undefined
                    }}>
                  {moment.utc(formData.auto_check_in_at).local().format(t('YYYY-MM-DD HH:mm'))}
                </span>
            </p>
          </div>
        }
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      {id &&
        <div className={"p-grid p-py-0 p-mt-1"} style={{clear: 'both'}}>
          <div className={"p-col p-py-0 p-my-0 reservation-status-timeline"}>
            <Timeline layout="horizontal" align="top"
                      value={statuses}
                      marker={(item, index) => {
                        let activeStep = statuses.filter(item => item.status === formData.status)
                        return (
                          <>
                            {formData.status === 'pending' &&
                              <>
                                {item.step === 0 ? (
                                  <>
                                    <i className={"pi pi-circle-fill"}
                                       style={{
                                         color: "#dddddd",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : (
                                  <>
                                    <i className={"pi pi-circle"}
                                       style={{
                                         color: "#dddddd",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                )}
                              </>
                            }
                            {formData.status === 'confirmed' &&
                              <>
                                {item.step === 0 ? (
                                  <>
                                    <i className={"pi pi-circle-fill"}
                                       style={{
                                         color: "#dddddd",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 1 ? (
                                  <>
                                    <i className={"pi pi-circle-fill"}
                                       style={{
                                         color: "#f1eea5",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : (
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#90959b",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       borderRadius: '100%'
                                     }}></i>
                                )}
                              </>
                            }
                            {formData.status === 'checked_in' &&
                              <>
                                {item.step === 0 ? (
                                  <>
                                    <i className={"pi pi-circle-fill"}
                                       style={{
                                         color: "#dddddd",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 1 ? (
                                  <>
                                    <i className={"pi pi-circle-fill"}
                                       style={{
                                         color: "#f1eea5",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 2 ? (
                                  <>
                                    <i className={"pi pi-circle-fill"}
                                       style={{
                                         color: "#3ec0e9",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : (
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#90959b",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       borderRadius: '100%'
                                     }}></i>
                                )}
                              </>
                            }
                            {(formData.status === 'checked_out' || formData.status === 'relocated') &&
                              <>
                                {item.step === 0 ? (
                                  <>
                                    <i className={"pi pi-circle-fill"}
                                       style={{
                                         color: "#dddddd",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 1 ? (
                                  <>
                                    <i className={"pi pi-circle-fill"}
                                       style={{
                                         color: "#f1eea5",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 2 ? (
                                  <>
                                    <i className={"pi pi-circle-fill"}
                                       style={{
                                         color: "#3ec0e9",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 3 ? (
                                  <>
                                    <i className={"pi pi-circle-fill"}
                                       style={{
                                         color: formData.status === 'relocated' ? '#fbc02d' : '#0abb87',
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : (
                                  <i className={"pi pi-circle"}
                                     style={{
                                       color: "#90959b",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       borderRadius: '100%'
                                     }}></i>
                                )}
                              </>
                            }
                            {formData.status === 'no_show' &&
                              <>
                                {item.step === 0 ? (
                                  <>
                                    <i className={"pi pi-circle"}
                                       style={{
                                         color: "#dddddd",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 1 ? (
                                  <>
                                    <i className={"pi pi-circle"}
                                       style={{
                                         color: "#f1eea5",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 2 ? (
                                  <>
                                    <i className={"pi pi-circle"}
                                       style={{
                                         color: "#3ec0e9",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 3 ? (
                                  <>
                                    <i className={"pi pi-circle"}
                                       style={{
                                         color: "#0abb87",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : (
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#8a2be2",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       borderRadius: '100%'
                                     }}></i>
                                )}
                              </>
                            }
                            {formData.status === 'cancelled' &&
                              <>
                                {item.step === 0 ? (
                                  <>
                                    <i className={"pi pi-circle"}
                                       style={{
                                         color: "#dddddd",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 1 ? (
                                  <>
                                    <i className={"pi pi-circle"}
                                       style={{
                                         color: "#f1eea5",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 2 ? (
                                  <>
                                    <i className={"pi pi-circle"}
                                       style={{
                                         color: "#3ec0e9",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : item.step === 3 ? (
                                  <>
                                    <i className={"pi pi-circle"}
                                       style={{
                                         color: "#0abb87",
                                         fontSize: '1.5rem',
                                         position: 'relative',
                                         zIndex: '9',
                                         borderRadius: '100%'
                                       }}></i>
                                  </>
                                ) : (
                                  <i className={"pi pi-circle-fill"}
                                     style={{
                                       color: "#f7a2a2",
                                       fontSize: '1.5rem',
                                       position: 'relative',
                                       zIndex: '9',
                                       borderRadius: '100%'
                                     }}></i>
                                )}
                              </>
                            }
                            {item.step !== 4 &&
                              <>
                                {activeStep[0]?.step === index && item.step !== 3 ? (
                                  <>
                                    <SplitButton label={
                                      <span>
                                        {t(activeStep[0]?.label === 'confrimed' ? 'reserved' : activeStep[0]?.label)}
                                        {item.date && item.date !== null &&
                                          <span style={{
                                            display: 'block',
                                            whiteSpace: 'nowrap',
                                            fontSize: '0.7rem'
                                          }}>
                                            {moment.utc(item.date).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                                          </span>
                                        }
                                      </span>
                                    }
                                                 id="buttonStatus"
                                                 onShow={() => {
                                                   apiCall('get', 'dictionary/reservation-status/next/default/' + formData.status)
                                                     .then(response => {
                                                       let _possibleStatuses = []
                                                       Object.entries(response.data.data).forEach(key => {
                                                         _possibleStatuses.push({
                                                           label: t(key[1] === 'confirmed' ? 'reserved' : key[1]),
                                                           command: () => {
                                                             setLoading(true)
                                                             axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation/" + formData.id,
                                                               {
                                                                 status: key[1]
                                                               },
                                                               {
                                                                 params: {},
                                                                 headers: {
                                                                   'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                                   "Sys-name": Cookies.get("instanceId"),
                                                                   "Preferred-locale": Cookies.get("language")
                                                                 }
                                                               })
                                                               .then(response => {
                                                                 setLoading(false)
                                                                 setFormData(response.data.data)
                                                                 if (['checked_in', 'checked_out'].includes(key[1])) {
                                                                   triggerAsyncStatusSyncRefresh();
                                                                 }
                                                                 window.App.setState({
                                                                   rerenderReservationList: Math.random(),
                                                                   rerenderReservationGuestList: Math.random(),
                                                                   rerenderReceiptList: Math.random()
                                                                 })
                                                               })
                                                               .catch(error => {
                                                                 setLoading(false)
                                                                 window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                               })
                                                           }
                                                         })
                                                       })
                                                       setPossibleStatuses(_possibleStatuses)
                                                     })
                                                     .catch(error => {
                                                       window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                                     })
                                                 }}
                                                 onClick={() => {
                                                   document.getElementById('buttonStatus').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                                                 }}
                                                 style={{
                                                   marginLeft: '-20px',
                                                   minWidth: '140px',
                                                   zIndex: 9,
                                                   position: 'relative'
                                                 }}
                                                 className={"p-button-sm button-status-" + item.status}
                                                 rounded
                                                 model={possibleStatuses}/>
                                  </>
                                ) : (
                                  <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    textWrap: "nowrap",
                                    whiteSpace: "nowrap"
                                  }}>
                                    &nbsp;
                                    {formData.status === 'relocated' && item.status === 'checked_out'
                                      ? t('relocated_checked_out')
                                      : t(item.status === 'confirmed' ? 'reserved' : item.status)}
                                    {item.date && item.date !== null &&
                                      <div style={{fontSize: '0.8rem'}}>
                                        &nbsp;
                                        {moment.utc(item.date).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                                      </div>
                                    }
                                  </div>
                                )}
                              </>
                            }
                            {item.step === 4 && (formData.status === 'cancelled' || formData.status === 'no_show') &&
                              <div style={{
                                display: "flex",
                                flexDirection: "column",
                                textWrap: "nowrap",
                                whiteSpace: "nowrap"
                              }}>
                                &nbsp;
                                {t(formData.status)}
                                {item.date && item.date !== null &&
                                  <div style={{fontSize: '0.8rem'}}>
                                    &nbsp;
                                    {moment.utc(item.date).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                                  </div>
                                }
                              </div>
                            }
                          </>
                        )
                      }}
            />
          </div>
        </div>
      }
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col"}>
          <Form onSubmit={onSubmit} initialValues={formData}
                validate={validate} render={({handleSubmit, form}) => (
            <form
              onSubmit={(event) => {
                const submitResult = handleSubmit(event);
                const formState = form.getState();
                if (formState.submitFailed && (formState.hasValidationErrors || formState.invalid)) {
                  window.App.toastShow('warn', t('warning'), t('reservation_submit_required_fields_invalid'));
                }
                return submitResult;
              }}
              className=""
            >
              <Panel className={"p-mt-0"}>
                <div className={"p-grid"}>
                  <div className={"p-col"}>
                    <h3 className={"p-mt-0 p-mb-0"}
                        style={{position: 'relative', bottom: '-3px'}}>{t('reservation_base_data')}</h3>
                  </div>
                  <div className={"p-col p-text-right p-col-align-center"}>
                    {formData && formData.id &&
                      <Button type="button" className="p-button-warning" icon={"pi pi-sign-in"}
                              disabled={!(['checked_in'].includes(formData.status)) || !!formData.relocated_to}
                              loading={loading}
                              label={t('relocate')}
                              onClick={() => {
                                if (window.location.hash.toString().includes('#/reservation')) {
                                  navigate('/reservation/update/' + formData.id + '?manage=relocate')
                                }
                                if (window.location.hash.toString().includes('#/calendar')) {
                                  navigate('/calendar/update/' + formData.id + '?manage=relocate')
                                }
                              }}/>
                    }
                    <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                            loading={loading}
                            onClick={() => {
                              props = {...props, closeForm: false}
                            }}
                            className="p-button-success p-ml-2"/>
                    {formData.id &&
                      <Button type="submit" aria-label={t('save_and_close')}
                              loading={loading}
                              onClick={() => {
                                props = {...props, closeForm: true}
                              }}
                              className="p-button-success p-ml-2">
                          <span>
                            <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                          </span>
                      </Button>
                    }
                  </div>
                </div>
                {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
                <HelpComponent type={"edit_box"}/>
                <HelpComponent type={"section"} tabNumber={0} sectionNumber={2}/>
                <div className={"p-grid"}>
                  <div className={"p-col"}>
                    <Field name="residential_unit" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"residential_unit"}/>
                        <label htmlFor="residential_unit"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('residential_unit')}</label>
                        <span className="p-inputgroup">
                          <Dropdown  options={unit}
                                    optionLabel="name"
                                    optionValue="id"
                                    placeholder={t('choose_residential_unit_placeholder')}
                                    filter
                                    id={"residential_unit"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        residential_unit: e.value,
                                        berth: null,
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        residential_unit: e.value,
                                        berth: null,
                                      })
                                    }}
                                    value={formData?.residential_unit?.id || formData.residential_unit}
                          />
                          {(chooseBerth === false && formData.residential_unit && berth && berth[0] && !formData.berth) &&
                            <Button icon="pi pi-inbox"
                                    label={t('reserve_berth')}
                                    className="p-button-secondary"
                                    type={"button"}
                                    onClick={() => {
                                      setChooseBerth(true)
                                    }}
                            />
                          }
                        </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  {(formData.residential_unit && berth && berth[0] && (chooseBerth == true || formData.berth)) &&
                    <div className={"p-col"}>
                      <Field name="berth" render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <HelpComponent type={"field"} field={"berth"}/>
                          <label htmlFor="berth"
                                 className={classNames({'p-error': isFormFieldValid(meta)})}>{t('berth')}</label>
                          <span className="">
                            <Dropdown  options={berth}
                                      optionLabel="name"
                                      optionValue="id"
                                      filter
                                      id={"berth"}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          berth: e.value
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          berth: e.value,
                                          residential_unit: formData.residential_unit
                                        })
                                      }}
                                      value={formData.berth}
                            />
                          </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}/>
                    </div>
                  }
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col-12"} style={{minWidth: '160px'}}>
                    <Field name="reserved_from" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"reserved_from"}/>
                        <label htmlFor="reserved_from"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('reserved_from')} - {t('reserved_to')}</label>
                        <span className="">
                          {dailyReservationOnly === true ? (
                            <>
                              <div className={"p-inputgroup"}>
                                <Calendar
                                  value={reservedFromDate ? moment(reservedFromDate, 'YYYY-MM-DD').toDate() : null}
                                  dateFormat={t('YY-MM-DD')}
                                  placeholder={reservedFromDate}
                                  locale="default"
                                  showOtherMonths
                                  selectOtherMonths
                                  id={"reserved_from"}
                                  onChange={(e) => {
                                    const nextReservedFromDate = e.value ? moment.utc(e.value).local().format(t('YYYY-MM-DD')) : null;
                                    setReservedFromDate(nextReservedFromDate)
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      reserved_from: nextReservedFromDate
                                    }))
                                    setNewFormData((prevState) => ({
                                      ...prevState,
                                      reserved_from: nextReservedFromDate
                                    }))
                                    input.onChange(nextReservedFromDate)
                                  }}/>
                                <Calendar value={reservedFromTime ? moment(reservedFromTime, 'HH:mm').toDate() : null}
                                          dateFormat={t('YY-MM-DD')}
                                          placeholder={reservedFromTime}
                                          locale="default"
                                          id={"reserved_from_time"}
                                          showIcon
                                          showTime={dailyReservationOnly}
                                          timeOnly={dailyReservationOnly}
                                          hourFormat="24"
                                          stepMinute={30}
                                          onChange={(e) => {
                                            setReservedFromTime(moment.utc(e.value).local().format('HH:mm'))
                                          }}/>
                                <Calendar value={reservedToDate ? moment(reservedToDate, 'YYYY-MM-DD').toDate() : null}
                                          dateFormat={t('YY-MM-DD')}
                                          placeholder={reservedToDate}
                                          locale="default"
                                          showOtherMonths
                                          selectOtherMonths
                                          id={"reserved_to"}
                                          onChange={(e) => {
                                            setReservedToDate(moment.utc(e.value).local().format(t('YYYY-MM-DD')))
                                          }}/>
                                <Calendar value={reservedToTime ? moment(reservedToTime, 'HH:mm').toDate() : null}
                                          placeholder={reservedToTime}
                                          locale="default"
                                          id={"reserved_to_time"}
                                          dateFormat={t('YY-MM-DD')}
                                          showIcon
                                          showTime={dailyReservationOnly}
                                          timeOnly={dailyReservationOnly}
                                          hourFormat="24"
                                          stepMinute={30}
                                          onChange={(e) => {
                                            setReservedToTime(moment.utc(e.value).local().format('HH:mm'))
                                          }}/>
                              </div>
                              {getFormErrorMessage(meta)}
                            </>
                          ) : reservationFromToInputType === 'merged' ? (
                            <>
                              <Calendar
                                id={"reserved_from"}
                                value={reservedFromDate ? [
                                  moment(reservedFromDate, 'YYYY-MM-DD').toDate(),
                                  reservedToDate ? moment(reservedToDate, 'YYYY-MM-DD').toDate() : null
                                ] : null}
                                locale="default"
                                dateFormat={t('YY-MM-DD')}
                                showOtherMonths
                                selectOtherMonths
                                selectionMode="range"
                                showIcon
                                onChange={(e) => {
                                  const nextReservedFromDate = e.value?.[0] ? moment.utc(e.value[0]).local().format(t('YYYY-MM-DD')) : null;
                                  const nextReservedToDate = e.value?.[1] ? moment.utc(e.value[1]).local().format(t('YYYY-MM-DD')) : null;
                                  setReservedFromDate(nextReservedFromDate)
                                  setReservedToDate(nextReservedToDate)
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    reserved_from: nextReservedFromDate,
                                    reserved_to: nextReservedToDate
                                  }))
                                  setNewFormData((prevState) => ({
                                    ...prevState,
                                    reserved_from: nextReservedFromDate,
                                    reserved_to: nextReservedToDate
                                  }))
                                  input.onChange(nextReservedFromDate)
                                }}
                              />
                              {getFormErrorMessage(meta)}
                            </>
                          ) : (
                            <>
                              <div className={"p-inputgroup"}>
                                <Calendar
                                  id={"reserved_from"}
                                  value={reservedFromDate ? moment(reservedFromDate, 'YYYY-MM-DD').toDate() : null}
                                  locale="default"
                                  dateFormat={t('YY-MM-DD')}
                                  showOtherMonths
                                  selectOtherMonths
                                  showIcon
                                  onChange={(e) => {
                                    const nextReservedFromDate = e.value ? moment.utc(e.value).local().format(t('YYYY-MM-DD')) : null;
                                    setReservedFromDate(nextReservedFromDate)
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      reserved_from: nextReservedFromDate
                                    }))
                                    setNewFormData((prevState) => ({
                                      ...prevState,
                                      reserved_from: nextReservedFromDate
                                    }))
                                    input.onChange(nextReservedFromDate)
                                  }}
                                />
                                <Calendar
                                  id={"reserved_to"}
                                  className={""}
                                  value={reservedToDate ? moment(reservedToDate, 'YYYY-MM-DD').toDate() : null}
                                  locale="default"
                                  dateFormat={t('YY-MM-DD')}
                                  showOtherMonths
                                  selectOtherMonths
                                  showIcon
                                  onChange={(e) => {
                                    const nextReservedToDate = e.value ? moment.utc(e.value).local().format(t('YYYY-MM-DD')) : null;
                                    setReservedToDate(nextReservedToDate)
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      reserved_to: nextReservedToDate
                                    }))
                                    setNewFormData((prevState) => ({
                                      ...prevState,
                                      reserved_to: nextReservedToDate
                                    }))
                                  }}
                                />
                              </div>
                              {getFormErrorMessage(meta)}
                            </>
                          )}
                          </span>
                      </div>
                    )}/>
                  </div>
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="channel" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"channel"}/>
                        <label htmlFor="channel"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('channel')}</label>
                        <span className="">
                          <Dropdown  options={chanel}
                                    optionLabel="name"
                                    optionValue="id"
                                    id={"channel"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        channel: e.value,
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        channel: e.value,
                                      })
                                    }}
                                    value={formData?.channel?.id || formData.channel}
                                    showClear
                          />
                        </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="price_category" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"rack_price_category"}/>
                        <label htmlFor="price_category"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('pricecategory')}</label>
                        <span className="">
                          <Dropdown  options={priceCategories}
                                    optionLabel="name"
                                    optionValue="id"
                                    id={"price_category"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        price_category: e.value,
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        price_category: e.value,
                                      })
                                    }}
                                    disabled={!formData.residential_unit}
                                    value={formData?.price_category?.id || formData.price_category}
                                    showClear
                          />
                        </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  {reservationGroup?.group?.name &&
                    <div className={"p-col-12 p-lg-6"}>
                      <div className="p-field p-fluid">
                        <label htmlFor="reservation_group_group">{t('group')}</label>
                        <span className="p-d-flex p-ai-center p-text-bold">
                          {reservationGroup?.group?.id &&
                            <>
                              <i className={"pi pi-window-maximize"}
                                 style={{cursor: 'pointer'}}
                                 onClick={() => {
                                   setGroupDialog(true)
                                 }}></i>
                              &nbsp;
                            </>
                          }
                          {reservationGroup.group.name}
                        </span>
                      </div>
                    </div>
                  }
                  <div className={"p-col-12 p-lg-12"}>
                    <Field name="note" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"note"}/>
                        <label htmlFor="note"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('note')}</label>
                        <span className="p-d-block">
                            <InputText id="note" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           note: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           note: e.target.value
                                         })
                                       }}
                                       value={formData.note}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-12"}>
                    <Field name="guest_information_request_page" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"guest_information_request_page"}/>
                        <label htmlFor="guest_information_request_page"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('guest_information_request_page')}</label>
                        <span className="p-inputgroup">
                        <Dropdown  options={guestInfos}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"guest_information_request_page"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      guest_information_request_page: e.value
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      guest_information_request_page: e.value
                                    })
                                  }}
                                  value={formData?.guest_information_request_page?.id || formData?.guest_information_request_page}
                                  showClear
                        />
                      </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="number_of_guests" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"number_of_guests"}/>
                        <label htmlFor="number_of_guests"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('number_of_guests')}</label>
                        <span className="p-d-block">
                            <InputText id="number_of_guests" {...input}
                                       keyfilter={"num"}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           number_of_guests: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           number_of_guests: e.target.value
                                         })
                                       }}
                                       value={formData.number_of_guests}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="daily_reservation_only" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"daily_reservation_only"}/>
                        <label htmlFor="daily_reservation_only"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('daily_reservation_only')}</label>
                        <span className="p-d-block">
                        {dailyReservationAllowed === true || (formData.reserved_to && moment(formData.reserved_to).diff(moment(formData.reserved_from), 'hours') < 12) ? (
                          <InputSwitch
                            className={"p-mt-1"}
                            name={"daily_reservation_only"}
                            value={dailyReservationOnly}
                            checked={dailyReservationOnly}
                            onChange={(e) => {
                              setDailyReservationOnly(e.value)
                              setReservedToDate(reservedFromDate)
                              setReservedFromTime('10:00')
                              setReservedToTime('11:00')
                            }}
                          />
                        ) : (
                          <span onClick={() => {
                            if (formData.residential_unit) {
                              window.App.customToastShow('warn', t('warning'), t('daily_reservation_not_allowed_by_accommodation'));
                            } else {
                              window.App.customToastShow('warn', t('warning'), t('choose_residential_unit_first'));
                            }
                          }}>
                            <InputSwitch
                              className={"p-mt-1"}
                              disabled
                            />
                          </span>
                        )}
                        </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>

                  {!id && action === 'create' &&
                    <div className={"p-col-12 p-lg-6"}>
                      <Field name="status" render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <HelpComponent type={"field"} field={"status"}/>
                          <label htmlFor="status"
                                 className={classNames({'p-error': isFormFieldValid(meta)})}>{t('status')}</label>
                          <span className="p-d-block">
                          <SplitButton
                            label={t((formData.status === 'confirmed' ? 'reserved' : formData.status) || 'no_status')}
                            id="buttonStatus"
                            onShow={() => {
                              setPossibleStatuses([
                                {
                                  label: t('pending'),
                                  value: "pending",
                                  command: () => {
                                    setFormData({
                                      ...formData,
                                      status: "pending"
                                    })
                                  }
                                },
                                {
                                  label: t('reserved'),
                                  value: "confirmed",
                                  command: () => {
                                    setFormData({
                                      ...formData,
                                      status: "confirmed"
                                    })
                                  }
                                },
                              ])
                            }}
                            onClick={() => {
                              document.getElementById('buttonStatus').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                            }}
                            className={
                              formData.status === 'cancelled'
                                ? 'p-button-danger'
                                : formData.status === 'pending'
                                  ? 'p-button-secondary'
                                  : ['no_show', undefined].includes(formData.status) || (!formData.id && formData.status === 'confirmed')
                                  ? 'p-button-warning'
                                  : ['confirmed', 'checked_in', 'checked_out'].includes(formData.status)
                                    ? 'p-button-success'
                                    : 'p-button-secondary'
                            }
                            model={possibleStatuses}/>
                          </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}/>
                    </div>
                  }
                </div>
              </Panel>
              <Panel className={"p-mt-3"}>
                <h3 className={"p-mt-0"}>
                  {t('contact')}
                </h3>
                <HelpComponent type={"section"} tabNumber={0} sectionNumber={2}/>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="contact_name" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"contact_name"}/>
                        <label htmlFor="contact_name"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_name')}</label>
                        <span className="p-d-block">
                            <InputText id="contact_name" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           contact_name: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           contact_name: e.target.value
                                         })
                                       }}
                                       value={formData.contact_name}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="contact_email" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"contact_email"}/>
                        <label htmlFor="contact_email"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_email')}</label>
                        <span className="p-d-block">
                            <InputText id="contact_email" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           contact_email: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           contact_email: e.target.value
                                         })
                                       }}
                                       value={formData.contact_email}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="contact_number" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"contact_number"}/>
                        <label htmlFor="contact_number"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_phone')}</label>
                        <span className="p-d-block">
                            <InputText id="contact_number" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           contact_number: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           contact_number: e.target.value
                                         })
                                       }}
                                       value={formData.contact_number}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                </div>
              </Panel>
              <Panel className={"p-mt-3"}>
                <h3 className={"p-mt-0 p-mb-1"}>
                  {t('hotelconnect_ntak_sync_panel_title')}
                </h3>
                <div className={"p-grid"}>
                  <div className={"p-col-12"}>
                    <ul className="p-pl-0 p-mt-3 p-mb-0" style={{listStyle: "none"}}>
                      {renderHotelConnectSyncRow(
                        'foglalas',
                        t('hotelconnect_ntak_foglalas_sync_row_label'),
                        hotelConnectFoglalasStatusMeta,
                        isHotelConnectFoglalasSyncFailed,
                        hotelConnectFoglalasError,
                        hotelConnectRetryLoading,
                        retryHotelConnectFoglalasSync
                      )}
                      {renderHotelConnectSyncRow(
                        'checkin',
                        t('hotelconnect_ntak_checkin_sync_row_label'),
                        hotelConnectCheckinStatusMeta,
                        isHotelConnectCheckinSyncFailed,
                        hotelConnectCheckinError,
                        hotelConnectCheckinRetryLoading,
                        retryHotelConnectCheckinSync
                      )}
                      {renderHotelConnectSyncRow(
                        'checkout',
                        t('hotelconnect_ntak_checkout_sync_row_label'),
                        hotelConnectCheckoutStatusMeta,
                        isHotelConnectCheckoutSyncFailed,
                        hotelConnectCheckoutError,
                        hotelConnectCheckoutRetryLoading,
                        retryHotelConnectCheckoutSync
                      )}
                      {showHotelConnectRoomChangeSync &&
                        renderHotelConnectSyncRow(
                          'room-change',
                          t('hotelconnect_ntak_room_change_sync_row_label'),
                          hotelConnectRoomChangeStatusMeta,
                          isHotelConnectRoomChangeSyncFailed,
                          hotelConnectRoomChangeError,
                          hotelConnectRoomChangeRetryLoading,
                          retryHotelConnectRoomChangeSync
                        )
                      }
                    </ul>
                  </div>
                </div>
              </Panel>
            </form>
          )}/>
        </div>
        {formData && formData.id &&
          <div className={"p-col-12 p-lg-8"}>
            {formData && formData.id &&
              <TabView>
                <TabPanel header={t('guests')} className={"p-px-0"}>
                  <HelpComponent type={"tab"} tabNumber={1}/>
                  <Panel className={"p-mt-0"}>
                    <h3 className={"p-mt-0"}>{t('checkin_form')}</h3>
                    <HelpComponent type={"section"} tabNumber={1} sectionNumber={1}/>
                    <div className={"p-grid"}>
                      <div className={"p-col p-text-right p-col-align-center"}>
                        {formData.errors && formData.errors[0] ? (
                          <></>
                        ) : (
                          <>
                            {formData.password && formData.unique_id &&
                              <Link to={process.env.REACT_APP_APP_PROTOCOL + window.location.hostname.split('.')[0]
                                + "." + process.env.REACT_APP_APP_HOST + "public-checkin?uniqueId=" + formData.unique_id + "&password=" + formData.password}
                                    target={"_blank"} className={"p-text-secondary"}
                              >
                                <i className={"pi pi-window-maximize"}
                                   style={{position: 'relative', bottom: '-1px'}}></i> {t('check_in_link')}
                              </Link>
                            }
                          </>
                        )}
                      </div>
                    </div>
                    {formData.errors && formData.errors[0] ? (
                      <div className={"p-mb-3"}>
                        <Message severity="warn" text={t('reservation_errror_checkin_disabled')}
                                 className={"p-d-block p-mt-1"}/>
                      </div>
                    ) : (
                      <>
                        <div className={"p-grid"}>
                          <div className={"p-col p-col-align-center"}>
                            <div className="p-field p-fluid">
                              <label htmlFor="email">{t('email')}</label>
                              <span className="p-d-block">
                            <InputText id="email"
                                       onChange={(e) => {
                                         setEmail({
                                           ...email,
                                           email: e.target.value
                                         })
                                       }}
                                       value={email.email}
                            />
                          </span>
                            </div>
                          </div>
                          <div className={"p-col-12 p-lg-3 p-col-align-center"}>
                            <div className="p-field p-fluid">
                              <label htmlFor="customer_count">{t('customer_count')}</label>
                              <span className="p-d-block">
                                <InputText id="customer_count"
                                           keyfilter={"num"}
                                           onChange={(e) => {
                                             setEmail({
                                               ...email,
                                               customer_count: e.target.value
                                             })
                                           }}
                                           value={email.customer_count}
                                />
                              </span>
                            </div>
                          </div>
                          <div className={"p-col-12 p-lg-1 p-col-align-center"}>
                            <div className="p-field p-fluid">
                              <label htmlFor="language">{t('language')}</label>
                              <span className="p-d-block">
                                <Dropdown options={[
                                  {label: 'HU', value: 'HU'},
                                  {label: 'EN', value: 'EN'},
                                ]}
                                          
                                          optionLabel="label"
                                          optionValue="value"
                                          id={"language"}
                                          emptyMessage={t('empty_message')}
                                          onChange={(e) => {
                                            setEmail({
                                              ...email,
                                              language: e.target.value
                                            })
                                          }}
                                          value={email.language}
                                />
                          </span>
                            </div>
                          </div>
                          <div className={"p-col-12 p-lg-2 p-col-align-center"}>
                            <Button type="button"
                                    label={t('send_email')}
                                    loading={loading}
                                    disabled={formData.errors && formData.errors[0]}
                                    icon={"pi pi-envelope"}
                                    onClick={() => {
                                      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation/"
                                        + formData.reservation_group.id + "/send-customer-data-form",
                                        email,
                                        {
                                          params: {},
                                          headers: {
                                            'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                            "Sys-name": Cookies.get("instanceId"),
                                            "Preferred-locale": Cookies.get("language")
                                          }
                                        })
                                        .then(response => {
                                          window.App.toastShow('success', t('success'), response.data.message)
                                        })
                                        .catch(error => {
                                          setLoading(false)
                                          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                        })

                                    }}
                                    className="p-mt-3 p-button p-button-block p-button-warning w-100"/>
                          </div>
                        </div>
                      </>
                    )}
                  </Panel>
                  <Panel className={"p-mt-3"}>
                    <h3 className={"p-mt-0"}>{t('guests')}</h3>
                    <HelpComponent type={"section"} tabNumber={1} sectionNumber={2}/>
                    <_FM_ReservationGuestListComponent reservation={formData}/>
                  </Panel>
                </TabPanel>
                <TabPanel header={t('folio')} className={"p-px-0"}>
                  <HelpComponent type={"tab"} tabNumber={2}/>
                  <Panel className={"p-mt-0"}>
                    <h3 className={"p-mt-0"}>{t('folio')}</h3>
                    <HelpComponent type={"section"} tabNumber={2} sectionNumber={1}/>
                    <_FM_FolioListComponent reservationGroupId={formData.reservation_group.id}/>
                  </Panel>
                </TabPanel>
                <TabPanel header={t('billing')} className={"p-px-0"}>
                  <HelpComponent type={"tab"} tabNumber={3}/>
                  <Panel className={"p-mt-0"}>
                    <HelpComponent type={"section"} tabNumber={3} sectionNumber={1}/>
                    <_FM_ReservationBillingdataFormComponent uniqueId={formData.unique_id}
                                                             password={formData.password}
                                                             billingData={formData?.reservation_group?.default_billing_data}/>
                  </Panel>
                </TabPanel>
                <TabPanel header={t('receipts')} className={"p-px-0"}>
                  <HelpComponent type={"tab"} tabNumber={4}/>
                  <Panel className={"p-mt-0"}>
                    <h3 className={"p-mt-0"}>{t('receipts')}</h3>
                    <HelpComponent type={"section"} tabNumber={4} sectionNumber={1}/>
                    <_FM_ReceiptListComponent groupId={formData.reservation_group.id}/>
                  </Panel>
                </TabPanel>
                <TabPanel header={t('reservation_group')} className={"p-px-0"}>
                  <HelpComponent type={"tab"} tabNumber={5}/>
                  <Panel className={"p-mt-0"}>
                    <h3 className={"p-mt-0"}>{t('reservation_group')}</h3>
                    <HelpComponent type={"section"} tabNumber={5} sectionNumber={1}/>
                    <_FM_ReservationAttachFormComponent groupId={formData.reservation_group.id}
                                                        reservation={formData}
                                                        status={formData.status}/>
                  </Panel>
                </TabPanel>
                {countrySpecificEnabled !== false &&
                  <TabPanel header={t('country_specific_settings')} className={"p-px-0"}>
                    <Panel className={"p-mt-0"}>
                      <ReservationCountrySpecificComponent
                        mode="edit"
                        reservation={formData}
                        onEnabledChange={setCountrySpecificEnabled}
                      />
                    </Panel>
                  </TabPanel>
                }
                {formData.price_snapshot && formData.price_snapshot.ezee ? (
                  <TabPanel header={t('ezee_prices')} className={"p-px-0"}>
                    <_FM_ReservationEzeepricesListComponent prices={formData.price_snapshot.ezee}/>
                  </TabPanel>
                ) : (
                  <></>
                )}
                {formData.resnweb_room_reference_id ? (
                  <TabPanel header={'RESnWEB '} className={"p-px-0"}>
                    <_FM_ReservationResnwebListComponent reservation={formData}/>
                  </TabPanel>
                ) : (
                  <></>
                )}
              </TabView>
            }
          </div>
        }
      </div>
      {formData.errors && formData.errors[0] &&
        <_FM_ReservationErrorsListComponent errors={formData.errors}/>
      }
      <Dialog header={t('group_form')}
              visible={groupDialog}
              onHide={() => {
                setGroupDialog(false)
              }}
              style={{minWidth: '960px', width: '80vw', maxWidth: '1200px'}}
              modal={false}>
        {reservationGroup?.group?.id &&
          <_FM_GroupFormComponent groupId={reservationGroup.group.id}
                                  onClose={() => {
                                    setGroupDialog(false)
                                  }}/>
        }
      </Dialog>
    </>
  )
}
export default withTranslation('common')(_FM_ReservationFormComponent);
